// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Int64LookupPagingResultModel from '../../model/int64-lookup-paging-result-model';
import Int64LookupPagingResultDTO from '../dto/int64-lookup-paging-result-dto';
import dtoSchema from '../schemas/int64-lookup-paging-result-schema';
import Int64LookupModel from '../../model/int64-lookup-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class Int64LookupPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Int64LookupPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => Int64LookupModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: Int64LookupModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<Int64LookupPagingResultDTO>): Int64LookupPagingResultModel;
  static toModel(dto: DeepPartial<Int64LookupPagingResultDTO> | undefined | null): Int64LookupPagingResultModel | undefined;
  static toModel(dto: DeepPartial<Int64LookupPagingResultDTO> | undefined | null): Int64LookupPagingResultModel | undefined {
    return dto ? new Int64LookupPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Int64LookupPagingResultModel> | Int64LookupPagingResultModel): Int64LookupPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as Int64LookupPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Int64LookupPagingResultModel, can not map to Int64LookupPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
